export default __webpack_public_path__ + "static/media/icon-wheelchair.543decaa.svg";